const constants = {
  SEARCH_TYPE: {
    ARTIST: 'SEARCH_TYPE_ARTIST',
    ALBUM: 'SEARCH_TYPE_ALBUM'
  }
};

module.exports = constants;



// WEBPACK FOOTER //
// ./src/constants/index.js